const ApiForms = {
    'body': '',
    'start': function(){
        let self = this;
        self.init();
        self.onEmailChange();
        self.setFileTrigger();

        self.setPasswordDisplay();
    },
    'setFileTrigger': function(){
        let self = this;
        let fileTriggers = self.body.find('[file-trigger]')
        // console.log('fileTrigger: '+fileTriggers.length);
        fileTriggers.unbind('click');
        fileTriggers.each(function(){
            let fileTrigger = $(this);
            let inputFile = fileTrigger.closest('div').find('input');
            fileTrigger.on('click', function(){
                let thisClick = $(this);
                inputFile.trigger('click');

                self.onChange(inputFile);
            });
        });
    },
    'onChange': function(inputFile){
        let self = this;
        let inputEmail = self.body.find('input[type=email]');
        let inputEmailValue = inputEmail.val();
        inputFile.unbind('change');
        inputFile.on('change', function(e){
           // console.log(e);
            let files = e.target.files[0];
            if (!files) return;
            //----------------------------------------------------------------------------------------------------------
            let ajaxName = 'uploadFile';
            //----------------------------------------------------------------------------------------------------------
            let formData = new FormData();
            formData.append('ajaxToken', _ajaxToken);
            formData.append('email', inputEmailValue);
            formData.append('files', files);

                let ajaxCall = $.ajax({
                    headers: {'X-CSRF-Token': _csrfToken},
                    url: _ajaxRoot  + 'ajax/' + ajaxName,
                    type: 'POST',
                    data: formData,
                    contentType: false,        // VERY IMPORTANT
                    processData: false,        // VERY IMPORTANT
                });
                //--------------------------------------------------------------------------------------------------------------
                ajaxCall.done(function(response) {
                    // console.log(response);
                    let ajaxResponse = response['ajax-response'];
                    let fileName = ajaxResponse['fileName'];
                    let orginalFileName = ajaxResponse['originalFileName'];
                    let textarea = inputFile.parent().parent().find('textarea[name=documents]');
                    // console.log(textarea.length);
                    let textareaJson = textarea.val();
                    if (textareaJson == '') textareaJson = '[]';
                    let textareaArray = JSON.parse(textareaJson);
                    textareaArray.push({
                        'fileName' : fileName,
                        'originalFileName' : orginalFileName,
                    });
                    textarea.val(JSON.stringify(textareaArray));
                    //--- display all images ----
                    self.displayImages(textareaArray);
                    self.removeDocument(textarea);
                });

        });

    },
    'displayImages': function(documentArray){
        let self = this;
        let documentContent = self.body.find('.panel-document-items');

        let html = '';
        for(let i=0;i<documentArray.length;i++){
            let fileName = documentArray[i]['fileName'];
            let originalFileName = documentArray[i]['originalFileName'];

            html += '<div class="panel-document-item">';

            html += '<div class="panel-document-item-icon">';
            html += '<img class="icon icon-large mob-icon-large" src="'+_icon+'icon-document-remove.webp'+'" doc-idx="'+i+'" file-remove onClick="return confirm(\'Are you sure?\');" >';
            html += '</div>';

            html += '<div class="panel-document-item-content">';
            html += '<div class="text-tiny font-poppins-regular">File Name:</div>';
            html += '<div class="text-tiny">'+originalFileName+'</div>';
            html += '</div>';

            html += '</div>';
        }
        documentContent.html(html);

    },
    'removeDocument': function(inputTextarea){
        let self = this;
        setTimeout(function(){
            let fileRemoves = self.body.find('[file-remove]');
            let textAreaJson = inputTextarea.val();
            if (textAreaJson == '') textAreaJson = '[]';
            let textareaArray = JSON.parse(textAreaJson);

            fileRemoves.unbind('click');
            fileRemoves.each(function(){
                let fileRemove = $(this);
                fileRemove.on('click', function(){
                    let onClick = $(this);
                    let docIdx = onClick.attr('doc-idx');
                    let documentRemoves = textareaArray[docIdx]??[];
                    textareaArray.splice(docIdx, 1);
                    textAreaJson = JSON.stringify(textareaArray);
                    inputTextarea.val(textAreaJson);
                    //--------------------------------------------------------------------------------------------------
                    let textareaDocRemove = inputTextarea.parent().parent().find('textarea[name="documents-remove"]');
                    let textareaDocRemoveJson = textareaDocRemove.val();
                    if (textareaDocRemoveJson == '') textareaDocRemoveJson = '[]';
                    let textareaDocRemoveArray = JSON.parse(textareaDocRemoveJson);
                    textareaDocRemoveArray.push(documentRemoves);
                    textareaDocRemove.val(JSON.stringify(textareaDocRemoveArray));
                    // console.log(textareaDocRemove.val());
                    //--------------------------------------------------------------------------------------------------
                    self.displayImages(textareaArray);
                    self.removeDocument(inputTextarea);
                });
            },20);
        });
    },
    'onEmailChange': function(){
        let self = this;
        let panelDocuments = self.body.find('.panel-documents');
        let inputEmails = self.body.find('input[type=email]');
        inputEmails.unbind('change');
        inputEmails.each(function(){
            let inputEmail = $(this);
            inputEmail.on('change', function(){
                let thisChange = $(this);
                let inputValue = thisChange.val();
                if (inputValue == ''){
                    panelDocuments.addClass('hidden');
                }else{
                    panelDocuments.removeClass('hidden');
                    self.start();
                }
            });
        });
    },
    'setPasswordDisplay': function(){
        let self = this;
        let passportDisplays = self.body.find('[password-display]');
        passportDisplays.unbind('click');
        console.log('xyyyxxx');
        console.log(passportDisplays.length);
        passportDisplays.each(function(){
            let passwordDisplay = $(this);
            passwordDisplay.on('click', function(){
                let thisClick = $(this);
                let icon = thisClick.find('i');
                let fieldGroup = thisClick.closest('div.field-group');
                let input = fieldGroup.find('input');


                switch(input.attr('type')){
                    case 'password':
                        input.attr('type','text');
                        thisClick.attr('src', _icon+'icon-eye-close.avif');
                        break;
                    default:
                        input.attr('type','password');
                        thisClick.attr('src', _icon+'icon-eye-open.avif');
                        break;
                }

            });
        })
    },
    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    ApiForms.start();
});
